import { ClientIntakeResponsesSelectors } from '@db-access/clientIntakeResponses';
import { createSelector } from '@ngxs/store';
import { calculateProgress, getStatusCounts } from '@globalUtils/client-intake';
import { IntakeResponseStatusCounts } from '@models/client-portal/client-intake-responses';
import { ClientIntakeResponse } from '@db-access/clientIntakeResponses';
import { IntakeFormContextSelectors } from '@domain/intake-form-context';
import { ClientIntakeFormType } from '@models/client-intake';

export class IntakeFormClientResponsesSelectors {
	static readonly dbClientIntakeFormResponses =
		ClientIntakeResponsesSelectors._props.items;

	static readonly $intakeFormResponses = createSelector(
		[
			IntakeFormClientResponsesSelectors.dbClientIntakeFormResponses,
			IntakeFormContextSelectors.$context,
		],
		(intakeFormResponses, context): ClientIntakeResponse[] => {
			const clientsContext = context.clients?.all.map((client) => client.id);
			const filteredCurrentResponses = intakeFormResponses.filter(
				(response) =>
					clientsContext?.includes(response.id) ||
					response.type === ClientIntakeFormType.GENERAL,
			);
			return filteredCurrentResponses;
		},
	);

	static readonly $intakeResponseStatusCounts = createSelector(
		[IntakeFormClientResponsesSelectors.$intakeFormResponses],
		(responses): IntakeResponseStatusCounts => {
			return getStatusCounts(responses);
		},
	);

	static readonly $intakeResponseMatterProgress = createSelector(
		[IntakeFormClientResponsesSelectors.$intakeResponseStatusCounts],
		(statusCounts) => {
			const progress = calculateProgress(
				statusCounts.total,
				statusCounts.addedToMatter,
			);

			return progress;
		},
	);
}
